export enum SvsViews {
  valueAndCause,
  svsLines,
  vatAndPayment,
  counterExpertise,
  remark,
  communication,
  signing
}
